import { serialiseOccupancy } from 'lib/search/occupancy'

/**
 * Stable cache/filter key for bedbank rates keyed by occupancy + stay dates.
 * Kept as a leaf util so selectors/mappers can use it without importing actions.
 */
export function getBedbankRateKey(
  occupants: Array<App.Occupants>,
  checkIn: string,
  checkOut: string,
): string {
  return `${checkIn}-${checkOut}-${serialiseOccupancy(occupants ?? []).join(',')}`
}
